import { render, staticRenderFns } from "./testRule.vue?vue&type=template&id=2e475063"
import script from "./testRule.vue?vue&type=script&lang=js"
export * from "./testRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports